import { Component } from '@angular/core';

@Component({
    selector: 'app-trabajadores',
    standalone: false,
    templateUrl: './trabajadores.component.html',
    styleUrls: ['./trabajadores.component.scss']
})
export class TrabajadoresComponent {

    constructor() { }
}
